import { cn } from "@/lib/utils";

/**
 * The co-brand: "Inkle × Curo".
 *
 * One line, not two. The partner's name and ours belong to the same phrase —
 * stacking them under a generic "Curo for teams" made the product look like
 * something bolted on beside their company rather than something running it.
 *
 * The × is a MULTIPLICATION SIGN, not a lowercase x. It is the collaboration
 * mark, it sits on the same optical centre as the surrounding caps, and a
 * letter x reads as a typo at this size.
 *
 * It is also deliberately quieter than both names: it is a connector, not a
 * word, and giving it equal weight makes the lockup read as three things
 * instead of two.
 */
export function OrgLockup({
	name,
	className,
}: { name: string | undefined; className?: string }) {
	if (!name) return null;
	return (
		<div className={cn("flex min-w-0 items-baseline gap-1.5", className)}>
			{/*
			 * The partner's name is what gets truncated, never the tail. A long
			 * company name that ate "× Curo" would leave the lockup meaningless —
			 * the whole point is the pairing, so the half that says so is the half
			 * that must survive.
			 */}
			<span className="truncate font-semibold text-heading">{name}</span>
			<span className="shrink-0 font-normal text-muted-foreground">×</span>
			<span className="shrink-0 font-semibold text-heading">Curo</span>
		</div>
	);
}
